export const ORDER_STATUS_TEXTS = {
  RECEIVED: 'Received',
  PREPARING: 'Preparing',
  PREPARED: 'Prepared',
  READY_TO_COLLECT: 'Ready to Collect',
  PARTIALLY_READY_TO_COLLECT: 'Partially Ready to Collect',
  ASSIGNED: 'Runner Assigned',
  PARTIALLY_ASSIGNED: 'Partially Runner Assigned',
  DELIVERED: 'Delivered',
  PATRON_CANCELLED: 'Cancelled',
  REJECTED: 'Rejected',
  REFUNDED: 'Refunded',
  PAYMENT_REJECTED: 'Payment Failed',
  PICKED: 'Runner Picked',
  PARTIALLY_PICKED: 'Partially Picked',
};

export const optionSymbol = {
  singleSelect: '',
  multiSelect: '+',
  optional: '',
  mandatory: '',
};
